// Removes a query param from the current URL without navigating or adding a history entry —
// used for one-shot params (deep links, feature flags) that should disappear once consumed.
export function stripQueryParam(key: string): void {
  const url = new URL(window.location.href);
  if (!url.searchParams.has(key)) return;

  url.searchParams.delete(key);
  window.history.replaceState(window.history.state, '', url.toString());
}
